import React from 'react';
import { func, node, oneOf, oneOfType, shape, string } from 'prop-types';

import classname from 'classnames';

import { PACKAGE_NAMESPACE_STYLED } from './constants';

const StyledLabel = ({
  accessibility_text,
  className = null,
  href = null,
  html_tag = 'span',
  id,
  onClick = null,
  styles,
  target,
  text = null,
}) => {
  const NAMESPACE = className ? `${PACKAGE_NAMESPACE_STYLED}-label ${className}` : `${PACKAGE_NAMESPACE_STYLED}-label`;
  const Element = html_tag || 'span';
  const LINK_NAMESPACE = `${PACKAGE_NAMESPACE_STYLED}__link`;

  if (html_tag === 'a' || href) {
    return (
      <a
        className={classname(NAMESPACE, id, LINK_NAMESPACE)}
        href={href ?? ''}
        onClick={onClick ?? null}
        style={{ ...styles }}
        target={target}
      >
        {text}
      </a>
    );
  }

  return (
    <Element
      className={classname(NAMESPACE, id)}
      onClick={onClick}
      style={{ ...styles }}
      ariaHidden={!!accessibility_text}
    >
      {text?.trim()}
    </Element>
  );
};

StyledLabel.propTypes = {
  accessibility_text: string,
  className: string,
  href: string,
  html_tag: oneOf(['p', 'span', 'h1', 'h2', 'h3', 'h4', 'li', 'a']),
  id: string,
  styles: shape({}),
  target: string,
  text: oneOfType([string, node]),
  onClick: func,
};

export default StyledLabel;
